<nav class="navbar navbar-dark bg-dark header">
  <a class="navbar-brand d-none d-sm-block" routerLink="dashboard">
    <img [src]="navLogo" alt="" class="logo" />
  </a>
  <app-drop-down [sites]="itemList"></app-drop-down>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    class="collapse navbar-collapse"
    id="navbarSupportedContent"
  >
    <ul class="navbar-nav mr-auto">
      <li
        [ngClass]="
          sharedData?.headerTab === CONSTANTS.DASHBOARD
            ? 'nav-item active'
            : 'nav-item'
        "
      >
        <a (click)="onSelected(CONSTANTS.DASHBOARD)" class="nav-link"
          >{{ 'DASHBOARD' | translate }} <span class="sr-only"></span
        ></a>
      </li>
      <li
        [ngClass]="
          sharedData?.headerTab === CONSTANTS.LOCATIONS
            ? 'nav-item active'
            : 'nav-item'
        "
      >
        <a (click)="onSelected(CONSTANTS.LOCATIONS)" class="nav-link"
          > {{ 'BUILDING' | translate }} <span class="sr-only"></span
        ></a>
      </li>
      <li
        [ngClass]="
          sharedData?.headerTab === CONSTANTS.USERS
            ? 'nav-item active'
            : 'nav-item'
        "
      >
        <a (click)="onSelected(CONSTANTS.USERS)" class="nav-link"
          > {{ 'USER' | translate }} <span class="sr-only"></span>
        </a>
      </li>
      <!-- <li class="nav-item">
        <a class="nav-link" (click)="openSupport()">{{ 'SUPPORT' | translate }}</a>
      </li> -->
      <li class="nav-item">
        <a class="nav-link" (click)="viewAccountSetting()"> {{ 'ACCOUNT_SETTING' | translate }}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="viewUserProfile()">{{ 'USER_PROFILE' | translate }}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="helpFaqs()"> {{ 'HELP_FAQ' | translate }} </a>
      </li>
      <div class="dropdown-divider"></div>
      <div class="col-md-10 col-lg-12 col-sm-12 col-xs-12 lgnDiv pl-20 ml-md-5">
        <button class="btn btn-danger lgnBtn" type="submit" (click)="logout()">
          {{ 'LOGOUT' | translate }}
        </button>
      </div>
    </ul>
  </div>
</nav>
